// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M25.948 7.98C23.356 6.685 19.916 6 16 6c-3.916 0-7.356.685-9.947 1.98C3.46 9.275 2 11.097 2 13v6c0 1.902 1.478 3.731 4.053 5.02C8.627 25.309 12.082 26 16 26c3.916 0 7.356-.685 9.948-1.98C28.538 22.725 30 20.903 30 19v-6c0-1.902-1.477-3.731-4.052-5.02ZM16 8c7.83 0 12 2.904 12 5s-4.17 5-12 5-12-2.904-12-5 4.17-5 12-5Zm-1 11.983v4c-2.375-.078-4.375-.428-6-.937v-3.915a25.43 25.43 0 0 0 6 .852Zm2 0a25.43 25.43 0 0 0 6-.852v3.914c-1.625.509-3.625.859-6 .936v-3.998ZM4 19v-2.309c.63.523 1.318.969 2.053 1.329.303.151.625.294.947.429v3.801c-1.979-.98-3-2.214-3-3.25Zm21 3.25v-3.801c.326-.135.644-.278.948-.429.734-.36 1.423-.806 2.052-1.329V19c0 1.036-1.021 2.27-3 3.25Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
